var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useUrlProps } from '../../common/urlProps';
import useLoginTheme from '../../common/useLoginTheme';
import AuthService from '../../domain/AuthService';
import gs from '../../styles/style';
import ErrorResponseHandler from '../Common/ErrorResponseHandler';
import { Errors, Form, Input, SubmitButton, useForm } from '../Common/Form';
import style from './RequestPasswordReset.scss';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var RequestPasswordReset = function () {
    useLoginTheme();
    var t = useTranslation()[0];
    var urlProps = useUrlProps();
    var _a = useState(false), success = _a[0], setSuccess = _a[1];
    var form = useForm({
        values: {
            email: urlProps.get('email')
        },
        onSubmit: function (data) {
            setSuccess(false);
            return AuthService.requestPasswordReset(data);
        },
        onSuccess: function () {
            setSuccess(true);
        }
    });
    return React.createElement("div", { className: style['request-password-reset-container'] },
        React.createElement(ErrorResponseHandler, null),
        React.createElement("h1", { className: gs('mb-5') }, t('lotus')),
        React.createElement("div", { className: gs('card') },
            React.createElement("div", { className: gs('card-body', style['request-password-reset-form']) },
                React.createElement(Form, { form: form },
                    React.createElement("h4", { className: gs('mt-2', 'text-center') },
                        React.createElement("span", { className: gs('text-muted') },
                            React.createElement(FontAwesomeIcon, { icon: "lock" })),
                        ' ',
                        t('forgot_password')),
                    React.createElement("hr", { className: gs('mt-4', 'mb-4') }),
                    React.createElement("fieldset", null,
                        !success && React.createElement(React.Fragment, null,
                            React.createElement("div", { className: gs('form-group') },
                                React.createElement("label", null, t('email')),
                                React.createElement(Input, __assign({}, form.string('email'), { autoFocus: true, className: gs('form-control-lg'), required: true })),
                                React.createElement(Errors, { attribute: "email", errors: form.getErrors('email') })),
                            React.createElement(SubmitButton, { form: form, className: gs('btn-block', 'btn-lg') }, t('reset_password'))),
                        success && t('password_reset_sent'),
                        React.createElement("div", { className: gs('mt-4', 'text-center', 'text-small') },
                            React.createElement(Link, { to: "/login".concat(urlProps.mergeLink({ email: form.values.email })), className: gs('text-muted') }, t('log_in'))))))));
};
export default RequestPasswordReset;
